import routes from './routes'
import { LobbyEntryProps, LobbyEntryTypes } from './components/LobbyEntry/LobbyEntry'

// backdrops
import Entrance from './images/backdrops/entrance.png'
import EntranceM from './images/backdrops/entranceP.png'
import Countdown from './images/backdrops/countdown.jpg'
import CountdownM from './images/backdrops/countdownM.jpg'
import LobbyL from './images/backdrops/lobby.jpeg'
import LobbyM from './images/backdrops/lobbyM.jpeg'
import Exhibition from './images/backdrops/exhibition.png'
import Registration from './images/backdrops/registration.jpg'
import RegistrationM from'./images/backdrops/registrationM.jpg'
import postRegistration from './images/backdrops/thankyou.jpg'
import postRegistrationM from'./images/backdrops/thankyouM.jpg'
import Auditorium from './images/backdrops/auditorium.jpeg'
import AuditoriumM from './images/backdrops/auditoriumM.jpeg'
import NetworkingL from './images/backdrops/networking.png'
import NetworkingM from './images/backdrops/networkingM.png'
import Gallerium from './images/backdrops/gallerium.jpg'

// audio
import LobbyMusic from './images/audio/lobby.mp3'

// icons & decorations
import closeLeftGlassDoor from './images/lobbyEntry/glass_closedoor_left.png'
import openLeftGlassDoor from './images/lobbyEntry/glass_opendoor_left.png'
import closeRightGlassDoor from './images/lobbyEntry/glass_closedoor_right.png'
import openRightGlassDoor from './images/lobbyEntry/glass_opendoor_right.png'
import closeLeftWoodDoor from './images/lobbyEntry/wood_closedoor_left.png'
import openLeftWoodDoor from './images/lobbyEntry/wood_opendoor_left.png'
import closeRightWoodDoor from './images/lobbyEntry/wood_closedoor_right.png'
import openRightWoodDoor from './images/lobbyEntry/wood_opendoor_right.png'
import InfoIcon from './images/lobbyEntry/infoIcon.png'
import PinIcon from './images/lobbyEntry/pinIcon2.gif'
import HandUpHover from './images/lobbyEntry/hand-up-hover.png'
import HandUpNormal from './images/lobbyEntry/hand-up-nor.png'
import { GlobalModalTypes } from './components/GlobalModals/GlobalModalContainer'

// speakers
import speaker1 from "src/images/event/speakers/1. Speaker Dmitriy Aksakov.png"
import speaker2 from "src/images/event/speakers/2. Speaker Norhalim Yunus.png"
import speaker3 from "src/images/event/speakers/3. Speaker Eva Gutierrez.png"
import speaker4 from "src/images/event/speakers/4. Speaker Arshad Mohamed Ismail.png"
import speaker5 from "src/images/event/speakers/5. Speaker Denis Owens Ochieng.png"
import speaker6 from "src/images/event/speakers/6. Speaker Smita Kuriakose.png"
import speaker7 from "src/images/event/speakers/7. Speaker Aria Putera Ismail.png"
import speaker8 from "src/images/event/speakers/8. Speaker Aditi Balbir.png"
import speaker9 from "src/images/event/speakers/9. Speaker Rolando B Victoria.png"
import speaker10 from "src/images/event/speakers/10. Planery Session Mohamed Rozani Osman.png"
import speaker11 from "src/images/event/speakers/11. Speaker Crispino Lobo.png"
import speaker12 from "src/images/event/speakers/12. Speaker Khadijah Iskandar.png"
import speaker13 from "src/images/event/speakers/13. Speaker Shri-C-S-R-Murthy.png"
import speaker14 from "src/images/event/speakers/14. Planery Session Datuk Dr. Anis Yusal Yusoff.png"
import speaker15 from "src/images/event/speakers/15. Speaker Edgardo S. Luzano.png"
import speaker16 from "src/images/event/speakers/15. Speaker Recai Biberoglu.png"
import speaker17 from "src/images/event/speakers/16. Speaker Zulfikri Osman.png"

import moderator1 from "src/images/event/speakers/Profile-Moderator-01-Rekha-Reddy.png"
import moderator2 from "src/images/event/speakers/Profile-Moderator-02-IIhami-Ozturk.png"
import moderator3 from "src/images/event/speakers/Profile-Moderator-03-Namita-Vikas.png"
import moderator4 from "src/images/event/speakers/Profile-Moderator-04-Firoz-Abdul-Hamid.png"

const dev = {
  apiUrl: 'http://localhost:4000',
  // apiUrl: 'https://globaldfiforum2021.herokuapp.com/',
}

const prod = {
  apiUrl: 'https://globaldfiforum2021.herokuapp.com/',
}

const API_KEYS = {
  amplitude: 'cb1ecde6afa5156e4391bd3fa28e6f54',
}

const VOLUME_VALUE = 0.4

// Root page will show either EntrancePage or CountdownPage
// based on the following time setting
const EVENT_START_TIME = {
  year: 2021,
  month: 11,
  day: 24,
  hour: 8,
  minute: 0,
}

const config = process.env.NODE_ENV === 'production' ? prod : dev

const assets = {
  entrance: {
    landscape: Entrance,
    portrait: EntranceM,
  },
  countdown: {
    landscape: Countdown,
    portrait: CountdownM,
  },
  lobby: {
    landscape: LobbyL,
    portrait: LobbyM,
  },
  auditorium1: {
    landscape: Auditorium,
    portrait: AuditoriumM,
  },

  registration: {
    landscape: Registration,
    portrait: RegistrationM,
  },

  postregistration: {
    landscape: postRegistration,
    portrait: postRegistrationM,
  },

  exhibition1: Exhibition,
  exhibition2: Exhibition,

  networking: {
    landscape: NetworkingL,
    portrait: NetworkingM,
  },
  gallerium: Gallerium,

  lobbyMusic: LobbyMusic,

  speakers: [
    speaker1,
    speaker2,
    speaker3,
    speaker4,
    speaker5,
    speaker6,
    speaker7,
    speaker8,
    speaker9,
    speaker10,
    speaker11,
    speaker12,
    speaker13,
    speaker14,
    speaker15,
    speaker16,
    speaker17,
    moderator1,
    moderator2,
    moderator3,
    moderator4,
  ],
}

const layout = {
  auditoriumVid: `
    top: 5%;
    bottom: 42%;
    left: 15%;
    right: 34%;
  `,
}

const lobbyEntries: Array<LobbyEntryProps & { id: string }> = [
  // {
  //   id: 'gameroom',
  //   type: LobbyEntryTypes.DirectRoute,
  //   destination: routes.networking,
  //   entryOpenImage: openRightGlassDoor,
  //   entryCloseImage: closeRightGlassDoor,
  //   css: `
  //     top: 0%;
  //     left: 66.4%;
  //     right: 26%;
  //     bottom: 63.8%;
  //   `,
  // },
  {
    id: 'auditorium',
    type: LobbyEntryTypes.DirectRoute,
    destination: routes.auditorium1,
    // destinations: [
    //   { name: 'Hall 1', route: routes.auditorium1 },
    //   { name: 'Lecture Hall B', route: routes.auditorium2 },
    // ],
    entryOpenImage: PinIcon,
    entryCloseImage: PinIcon,
    css: `
      top: 48.8%;
      left: 48.5%;
      right: 46.5%;
      bottom: 43%;
    `,
  },
  {
    id: 'exhibition',
    type: LobbyEntryTypes.MultiRoutes,
    selectionTitle: 'Please select a hall:',
    destinations: [
      { name: 'Hall 1', route: routes.exhibition1 },
      { name: 'Hall 2', route: routes.exhibition2 },
    ],
    entryOpenImage: PinIcon,
    entryCloseImage: PinIcon,
    css: `
      top: 48.8%;
      right: 64%;
      bottom: 43%;
    `,
  },
  {
    id: 'networking',
    type: LobbyEntryTypes.DirectRoute,
    destination: routes.networking,
    entryOpenImage: PinIcon,
    entryCloseImage: PinIcon,
    css: `
      top: 48.8%;
      right: 29.5%;
      left: 65.5%;
      bottom: 43%;
    `,
  },
  // {
  //   id: 'gallerium',
  //   type: LobbyEntryTypes.DirectRoute,
  //   destination: routes.onDemand,
  //   entryOpenImage: openRightGlassDoor,
  //   entryCloseImage: closeRightGlassDoor,
  //   css: `
  //     top: 29.5%;
  //     left: 66.4%;
  //     right: 26%;
  //     bottom: 63.8%;
  //   `,
  // },
  // {
  //   id: 'helpdesk',
  //   type: LobbyEntryTypes.Helpdesk,
  //   pinImage: InfoIcon,
  //   css: `
  //     top: 74%;
  //     left: 32%;
  //     right: 70%;
  //     bottom: 40.5%;
  //   `,
  // },
  // {
  //   id: 'sample-global-modal-lobby-entry-please-delete',
  //   type: LobbyEntryTypes.GlobalModal,
  //   modalId: GlobalModalTypes.CPD,
  //   pinText: 'I am Table',
  //   pinImage: PinIcon,
  //   entryOpenImage: HandUpHover,
  //   entryCloseImage: HandUpNormal,
  //   css: `
  //     top: 79%;
  //     left: 77%;
  //     right: 15%;
  //     bottom: 5.5%;
  //   `,
  // },
]

const hallLiveUrls = {
  hall1: "https://vimeo.com/event/1531637/embed",
}

export default {
  API_KEYS,
  assets,
  layout,
  lobbyEntries,
  hallLiveUrls,
  VOLUME_VALUE,
  EVENT_START_TIME,

  eventName: 'Global DFI Forum 2021 Malaysia',

  ...config,
}
